// 파비콘 동적 설정 유틸리티
export const setFavicon = () => {
  // 기존 파비콘 링크들 제거
  const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
  existingFavicons.forEach(link => link.remove());

  // 새로운 파비콘 링크들 추가
  const faviconLinks = [
    { rel: 'shortcut icon', href: '/favicon.ico?v=4' },
    { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico?v=4' },
    { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32.png?v=4' },
    { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16.png?v=4' },
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon-180.png?v=4' }
  ];

  faviconLinks.forEach(linkData => {
    const link = document.createElement('link');
    Object.keys(linkData).forEach(key => {
      link.setAttribute(key, linkData[key]);
    });
    document.head.appendChild(link);
  });
};
